import { Component, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';

import { CguTypeEnum } from '../../../shared/components/conditions-generales/cgu.model';
import { TrackingAction } from '../../../shared/model/tracking/tracking.enum';
import { RattachementService } from '../../rattachement.service';

@Component({
    selector: 'jhi-avertissements',
    templateUrl: './avertissements.component.html',
    styleUrls: ['avertissements.scss']
})
export class AvertissementsComponent {
    isSubmitted: boolean;

    // For validation only
    _cgu = false;
    _teleprocedures = false;

    cguTypeEnum = CguTypeEnum.CGU_RATTACHEMENT;

    @ViewChild(NgForm) form: NgForm;

    constructor(private router: Router, private rattachementService: RattachementService) {}

    previous() {
        this.router.navigate(['/']);
    }

    next() {
        this.isSubmitted = true;
        if (this.form.valid) {
            this.rattachementService.trackCguEvent(TrackingAction.SUCCESS);
            this.router.navigate(['rattachement/rejoindre-dossier']);
        } else {
            this.rattachementService.trackCguEvent(TrackingAction.FAILED);
        }
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/rattachement/steps/avertissements/avertissements.component.ts